import { render, staticRenderFns } from "./NewContentHeaderSectionManabi.vue?vue&type=template&id=0b1ca0b7&scoped=true&"
import script from "./NewContentHeaderSectionManabi.vue?vue&type=script&lang=ts&"
export * from "./NewContentHeaderSectionManabi.vue?vue&type=script&lang=ts&"
import style0 from "./NewContentHeaderSectionManabi.vue?vue&type=style&index=0&id=0b1ca0b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ca0b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
